export function tagName(name: string) {
  return `a-${name}`;
}
